import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';

import { COLORS } from '../IndividualPlan/tokens';

type MatchColumnsPromptDialogProps = {
  open: boolean;
  onCancel: () => void;
  onStartMatching: () => void;
};

export function MatchColumnsPromptDialog({ open, onCancel, onStartMatching }: MatchColumnsPromptDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, color: COLORS.ink, pb: 1 }}>
        CSV Column matching required
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, color: COLORS.muted, lineHeight: 1.5 }}>
          Before this file can be used in data processing for reports and plans generation you need to
          match the columns in your data with the data fields used for processing.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Link
          component="button"
          underline="hover"
          onClick={onCancel}
          sx={{ color: COLORS.navy, fontWeight: 600, fontSize: 14, mr: 2 }}
        >
          Cancel
        </Link>
        <Button
          variant="contained"
          onClick={onStartMatching}
          sx={{
            bgcolor: COLORS.navy,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
            borderRadius: 1.5,
            '&:hover': { bgcolor: '#18185A' },
          }}
        >
          Start Matching
        </Button>
      </DialogActions>
    </Dialog>
  );
}
